module.exports = __webpack_public_path__ + "static/dei_clip-bc85b4d2a7434e8a94a94892fb498aaf.png";